import React from 'react';
import ReportPage from '../ReportChart/ReportPage';
import { Apis } from "services/api";
import { getDefectsByType } from "services/analytics";
import useChartColors from '../ReportChart/hooks/useChartColors';

const DefectsTypeReport = () => {
  const { customCaptions } = JSON.parse(sessionStorage.getItem("me")) || JSON.parse(localStorage.getItem("me"));
  const { getAllColors } = useChartColors();

  const chartConfig = {
    id: 'defects-by-type',
    title: `${customCaptions?.defectPlural} by Type`,
    fetchData: async (params) => {
      return await getDefectsByType(params);
    },
    allowedChartTypes: ['tree-map', 'pie', 'vertical-bar', 'horizontal-bar'],
    defaultChartType: 'tree-map',
    axisConfig: {
      categoryAxis: { 
        dataKey: 'label', 
        type: 'category', 
        angle: 0,
        textAnchor: 'middle'
      },
      valueAxes: [{ 
        label: 'Count' 
      }]
    },
    series: [
      { 
        label: 'Count', 
        key: 'count', 
        showLegend: false,
        colors: getAllColors(),
        type: 'bar'
      }
    ],
    transformData: (response) => {
      return response?.data?.data;
    },
    filters: {
      timeframe: {
        allowCustomRange: true,
        defaultRange: 'show-all',
      },
      department: { multiSelect: true },
      model: true,
      riskRatings: true
    },
    viewData: '/app/defects', //This could be a function that returns the path based on the data
    itemNavigation: true,
    drilldown: {
      defaultChartType: 'tree-map',
      allowedChartTypes: ['tree-map', 'pie', 'vertical-bar', 'horizontal-bar'],
      axisConfig: {
        categoryAxis: { dataKey: 'label', type: 'category' },
        valueAxes: [{ 
          label: 'Count' 
        }]
      },
      series: [
        { 
          label: 'Count', 
          key: 'count', 
          showLegend: false,
          colors: getAllColors(),
          type: 'bar'
        }
      ],
      currentDrilldownLabel: `${customCaptions?.asset || 'Asset'}`,
      getParams: (dataPoint) => {
        return {
          defectTypeId: dataPoint.id,
          // LEGACY HANDLING: Add the legacy defectType structure for backward compatibility
          // This should be removed once we fully support URL param passing - EMI3FE-111
          defectType: {
            id: dataPoint.id,
            name: dataPoint.name || "Show All"
          }
        };
      },
    }
  };

  return (
    <ReportPage 
      title={`${customCaptions?.defectPlural} by ${customCaptions?.type || 'Type'}`}
      chartConfig={chartConfig}
    />
  );
};

export default DefectsTypeReport; 
